import { render, staticRenderFns } from "./UserInvitationList.vue?vue&type=template&id=fd9af8e4&scoped=true&"
import script from "./UserInvitationList.vue?vue&type=script&lang=js&"
export * from "./UserInvitationList.vue?vue&type=script&lang=js&"
import style0 from "./UserInvitationList.vue?vue&type=style&index=0&id=fd9af8e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd9af8e4",
  null
  
)

export default component.exports